module.exports = __webpack_public_path__ + "static/media/hall-AH.1eee9cea.svg";